"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cNewReportDefinitionZodObj = exports.cUpdateReportDefinitionZodObj = exports.ReportDefinitionObj = exports.cReportFilterDefinitionObj = exports.StatsObj = exports.GroupByObj = exports.cReportFilterDefInQuery = exports.cDateFilterObjQuery = exports.cReportFilterDefIn = exports.GraphTypeObj = exports.cAverageByDataTypeObj = exports.cGroupByDataTypeObj = void 0;
var zod_1 = require("zod");
var constants_1 = require("./constants");
var userLists_1 = require("../../userLists");
var insights_1 = require("../../insights");
var currencies_1 = require("../../currencies");
exports.cGroupByDataTypeObj = zod_1.z.enum(constants_1.cGroupByDataTypeOpts);
exports.cAverageByDataTypeObj = zod_1.z.enum([
    constants_1.cStatDataType.user,
    constants_1.cStatDataType.entity,
    constants_1.cStatDataType.page,
    constants_1.cStatDataType.userSearchTerm,
    constants_1.cStatDataType.entitySearchTerm,
    constants_1.cStatDataType.searchFilter,
    constants_1.cStatDataType.link,
    constants_1.cStatDataType.communicationAuthor
]);
var cSplitIntoSeriesByObj = zod_1.z.enum(__spreadArray(__spreadArray([], constants_1.cGroupByDataTypeOpts, true), ['off'], false));
exports.GraphTypeObj = zod_1.z.enum(constants_1.cGraphTypes);
var AllTimeDateFilterDefinitionObject = zod_1.z.object({
    operator: zod_1.z.literal(constants_1.cDateFilterOperatorOptions.allTimes)
});
var RollingDateRangeFilterDefinitionObject = zod_1.z.object({
    operator: zod_1.z.literal(constants_1.cDateFilterOperatorOptions.rollingRange),
    dateUnit: zod_1.z.enum(constants_1.rollingRangeDateUnitOpts),
    rollingValue: zod_1.z.coerce.number()
});
var FixedDateRangeDefinitionObject = zod_1.z.object({
    operator: zod_1.z.literal(constants_1.cDateFilterOperatorOptions.fixedRange),
    from: zod_1.z.string(),
    to: zod_1.z.string()
});
var cRollingDateRangeFilterDefinitionObjectQuery = zod_1.z.object({
    operator: zod_1.z.literal(constants_1.cDateFilterOperatorOptions.rollingRange),
    dateUnit: zod_1.z.enum(constants_1.rollingRangeDateUnitOpts),
    rollingValue: zod_1.z.string()
});
var cFixedDateRangeDefinitionObjectQuery = zod_1.z.object({
    operator: zod_1.z.literal(constants_1.cDateFilterOperatorOptions.fixedRange),
    from: zod_1.z.string(),
    to: zod_1.z.string()
});
var cDateFilterObj = zod_1.z.union([
    RollingDateRangeFilterDefinitionObject,
    AllTimeDateFilterDefinitionObject,
    FixedDateRangeDefinitionObject
]);
exports.cReportFilterDefIn = zod_1.z.object({
    date: cDateFilterObj.optional()
});
// `cDateFilterObjQuery` is the same as `cDateFilterObj`, except 
// for numbers — they're sent as `${number}` instead and will
// need parsing.
exports.cDateFilterObjQuery = zod_1.z.union([
    cRollingDateRangeFilterDefinitionObjectQuery,
    cFixedDateRangeDefinitionObjectQuery,
    AllTimeDateFilterDefinitionObject
]);
exports.cReportFilterDefInQuery = zod_1.z.object({
    date: exports.cDateFilterObjQuery
});
var cUserListFilterObj = zod_1.z.object({
    userListIdIn: zod_1.z.array(zod_1.z.string())
});
var cConceptFilterObj = zod_1.z.object({
    conceptIdIn: zod_1.z.array(zod_1.z.string())
});
var cEntityFilterObj = zod_1.z.object({
    entityIdIn: zod_1.z.array(zod_1.z.string().uuid())
});
var cBlockIdFilterObj = zod_1.z.object({
    blockIdIn: zod_1.z.array(zod_1.z.string())
});
var cAccountIdFilterObj = zod_1.z.object({
    accountIdIn: zod_1.z.array(zod_1.z.number())
});
var cApplicationStateFilterObj = zod_1.z.array(zod_1.z.nativeEnum(userLists_1.ListMembershipState));
var groupByDate = zod_1.z.object({
    groupByKey: zod_1.z.literal(constants_1.cGroupByKey.date),
    groupByValue: constants_1.cGroupByDateObj
});
var groupByDataType = zod_1.z.object({
    groupByKey: zod_1.z.literal(constants_1.cGroupByKey.dataKey),
    groupByValue: exports.cGroupByDataTypeObj
});
exports.GroupByObj = zod_1.z.union([groupByDataType, groupByDate]);
exports.StatsObj = zod_1.z.array(zod_1.z.object({
    statName: insights_1.availableStatsEnum,
    graphTypeOverride: zod_1.z.optional(exports.GraphTypeObj),
    boostValue: zod_1.z.optional(zod_1.z.number()),
    color: zod_1.z.optional(zod_1.z.string())
})).min(1);
exports.cReportFilterDefinitionObj = zod_1.z.object({
    date: zod_1.z.optional(cDateFilterObj),
    userList: zod_1.z.optional(cUserListFilterObj),
    applicationStates: zod_1.z.optional(cApplicationStateFilterObj),
    concepts: zod_1.z.optional(cConceptFilterObj),
    entities: zod_1.z.optional(cEntityFilterObj),
    accountId: zod_1.z.optional(cAccountIdFilterObj),
    blockId: zod_1.z.optional(cBlockIdFilterObj)
});
exports.ReportDefinitionObj = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    title: zod_1.z.string().max(50),
    opts: zod_1.z.object({
        stats: exports.StatsObj,
        isEngagementReport: zod_1.z.optional(zod_1.z.boolean()),
        yearlyModifier: zod_1.z.optional(zod_1.z.number()),
        groupBy: exports.GroupByObj,
        splitIntoSeriesBy: zod_1.z.optional(cSplitIntoSeriesByObj),
        maxNumberOfSeries: zod_1.z.optional(zod_1.z.number()),
        limitOnCategories: zod_1.z.optional(zod_1.z.number()).or(zod_1.z.boolean()),
        doubleSize: zod_1.z.optional(zod_1.z.boolean().nullable()),
        sort: zod_1.z.optional(zod_1.z.enum(constants_1.cSortOptions)),
        shouldCombineSeries: zod_1.z.optional(zod_1.z.boolean()),
        /**
         * When enabled, for each series, an accumulation of data over time
         * is calculated. This only works when grouping data by date.
         */
        includeCompound: zod_1.z.optional(zod_1.z.boolean()),
        onlyShowCompoundSeries: zod_1.z.optional(zod_1.z.boolean()),
        graphColor: zod_1.z.optional(zod_1.z.string()),
        graphShouldBeHorizontal: zod_1.z.optional(zod_1.z.boolean()),
        displayMode: zod_1.z.enum(['graph', 'table']),
        graphType: exports.GraphTypeObj,
        filters: zod_1.z.optional(exports.cReportFilterDefinitionObj),
        monetaryValueCurrency: zod_1.z.optional(currencies_1.cCurrencyCodesZod).nullable(),
        monetaryValueMultiplier: zod_1.z.optional(zod_1.z.number().positive()).nullable()
    })
});
exports.cUpdateReportDefinitionZodObj = exports.ReportDefinitionObj.omit({
    id: true
});
exports.cNewReportDefinitionZodObj = exports.ReportDefinitionObj.omit({
    id: true
});
